import { useEffect, useState } from 'react'

interface Reaction {
  id: string
  type: string
  emoji: string
  userId: string
  timestamp: number
}

interface ReactionDisplayProps {
  reactions: Reaction[]
  duration?: number
}

function ReactionDisplay({ reactions, duration = 3000 }: ReactionDisplayProps) {
  const [displayReactions, setDisplayReactions] = useState<Reaction[]>([])

  useEffect(() => {
    // 新しいリアクションを追加
    const newReactions = reactions.filter(
      r => !displayReactions.find(dr => dr.id === r.id)
    )

    if (newReactions.length > 0) {
      setDisplayReactions(prev => [...prev, ...newReactions])

      // 一定時間後に削除
      newReactions.forEach(reaction => {
        setTimeout(() => {
          setDisplayReactions(prev => prev.filter(r => r.id !== reaction.id))
        }, duration)
      })
    }
  }, [reactions, duration])

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      {displayReactions.map((reaction, index) => (
        <div
          key={reaction.id}
          className="absolute animate-float-up"
          style={{
            left: `${20 + (index * 15) % 60}%`,
            bottom: '100px',
            animation: `floatUp ${duration}ms ease-out forwards`,
          }}
        >
          <span className="text-4xl animate-wiggle">
            {reaction.emoji}
          </span>
        </div>
      ))}
    </div>
  )
}

export default ReactionDisplay